<script setup lang="ts">
import { vOnClickOutside } from "@vueuse/components"

const show = defineModel({
  default: false,
})
</script>

<template>
  <Transition name="fade-in-zoom" mode="out-in">
    <div
      v-if="show"
      v-on-click-outside="() => show = false"
      class="top-15 absolute z-30 w-full overflow-hidden shadow-lg"
    >
      <slot />
    </div>
  </Transition>
</template>
